import axios from 'axios';
var FAVORITE_SPOTS_PATH = '/favorite_spots';
export var favoriteSpotsPath = function favoriteSpotsPath(id) {
  if (id) {
    return "".concat(FAVORITE_SPOTS_PATH, "/").concat(id);
  }

  return FAVORITE_SPOTS_PATH;
};

function authToken(userToken, key) {
  return "Token token=\"".concat(key, "\", user=\"").concat(userToken, "\"");
}

export default function api(_ref) {
  var userToken = _ref.userToken,
      key = _ref.key,
      url = _ref.url;
  return axios.create({
    baseURL: "".concat(url, "/v2/"),
    headers: {
      Authorization: authToken(userToken, key)
    }
  });
}